module.exports = __webpack_public_path__ + "img/17.a77a8cf9.png";